import { render, staticRenderFns } from "./ASrecommendations.vue?vue&type=template&id=4858b402"
import script from "./ASrecommendations.vue?vue&type=script&lang=js"
export * from "./ASrecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports